module.exports = __webpack_public_path__ + "media/images/education/icon-circle-b135b182706e423fad2c7795f4c3ceb0.svg";